import { render, staticRenderFns } from "./ContainerSketch.vue?vue&type=template&id=0812879f&scoped=true"
import script from "./ContainerSketch.vue?vue&type=script&lang=js"
export * from "./ContainerSketch.vue?vue&type=script&lang=js"
import style0 from "./ContainerSketch.vue?vue&type=style&index=0&id=0812879f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812879f",
  null
  
)

export default component.exports